export const massCommunication = {
  navBar_sections_massCommunication: 'Mass Communication',
  mass_communication_creation_success: 'Mass communication created successfully',
  mass_communication_creation_error: 'Mass communication creation error',
};
